// removed by extract-text-webpack-plugin
module.exports = {"breadcrumb-list":"breadcrumb-list__kLk5C"};


//////////////////
// WEBPACK FOOTER
// ./styles/breadcrumb.scss
// module id = 287
// module chunks = 68